
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";

import { Actions } from "@/store/enums/StoreEnums";
import draggable from "vuedraggable";
import { formatDate } from "@/core/helpers/DatetimeConverter";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "LeaguesTablesWidget",
  components: {  draggable },

  props: {
    widgetClasses: String,
    routeKey: String,
  },

  setup(props) {
    const store = useStore();
    const page = ref(1);

    const getDynamicList = computed({
      get() {
        return store.getters.getDynamicList({ key: props.routeKey });
      },
      set(value) {
        store.dispatch(Actions.SET_DYNAMIC_LIST, {
          key: props.routeKey,
          list: value,
        });
      },
    });

    const moveItemToTop = (item) => {
      const currentList = [...(getDynamicList.value as any[])]; // 👈 key fix here
      const filtered = currentList.filter((i) => i.id !== item.id);
      filtered.unshift(item);
      getDynamicList.value = filtered;
    };

    const getPaginationParams = computed(() => {
      return store.getters.getPaginationParams({ key: props.routeKey });
    });

    const getSortBy = computed(() => {
      return store.getters.getSortBy({ key: props.routeKey });
    });

    const paginateItems = () => {
      store.dispatch(Actions.GET_DYNAMIC_LIST, {
        key: props.routeKey,
        page: getPaginationParams.value.currentPage,
      });
    };

    const getMapping = computed(() => {
      return store.getters.getMapping({ key: props.routeKey });
    });

    const pageName = computed(() => {
      const name =
        Object.keys(store.getters.getCatalogueParentCategory).length > 0
          ? store.getters.getCatalogueParentCategory.name
          : "";
      if (name === "" && getMapping.value?.map?.columnMapping) {
        return getMapping.value.map.columnMapping.Plural;
      }
      return name;
    });

    const dragOptions = computed(() => ({
      animation: 0,
      group: "description",
      disabled: false,
      ghostClass: "ghost",
    }));

    const toggleModal = (id) => {
      store.dispatch(Actions.SETUP_FORM_COMPONENT_OR_MODAL, {
        key: props.routeKey,
        id,
      });
    };

    const removeFilter = (key) => {
      store.dispatch(Actions.CLEAR_FILTER_TAG, {
        attrKey: key,
        key: props.routeKey,
      });
    };

    const deleteItem = (id, index) => {
      Swal.fire({
        text: "Are you sure you want to delete this item?",
        icon: "error",
        buttonsStyling: true,
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn",
        },
      }).then((deleted) => {
        if (deleted.isConfirmed) {
          store.dispatch(Actions.DELETE_ITEM, {
            key: props.routeKey,
            id,
            index,
          });
        }
      });
    };

    const toggleQrCode = (id) => {
      store.dispatch(Actions.SET_ENTITY_ID, { id, key: props.routeKey });
    };

    const getAppliedFilterValues = computed(() => {
      return store.getters.getAppliedFilterValues({ key: props.routeKey });
    });

    const getCatalogueParentCategory = computed(() => {
      return store.getters.getCatalogueParentCategory({ key: props.routeKey });
    });

    return {
      getPaginationParams,
      paginateItems,
      getSortBy,
      pageName,
      page,
      formatDate,
      toggleModal,
      toggleQrCode,
      deleteItem,
      getAppliedFilterValues,
      removeFilter,
      dragOptions,
      getDynamicList,
      getMapping,
      getCatalogueParentCategory,
      moveItemToTop, // ⬅️ included here
    };
  },
});
